/*
@author: Nikhil 

jvInputDropDown
============
@desc: Used to show a drop of items next to an input 

 */
angular.module('jv.Common.Directives.inputDropDown', [])
.directive('jvInputDropdown',['$timeout',function($timeout){
        var html = '';
        html += '<ul class="dark-pri-bg blue text-center float-left dropdown-trigger">';
        html += '<li class="selected padding-left-x-small padding-right-x-small"><a ng-click="toggleDropDown()"><i class="icon icon-search"></i><i class="icon icon-down-triangle x-small triangle"></i></a></li>';
        html += '<ul ng-show="showDropDown" class="float-left dropdown-list">';
        html += '<li ng-repeat="item in dropdownList" class="text-left border-border-bottom padding-top-x-small padding-bottom-x-small w10"><a ng-click="loadSelectedDropDown(item)" class="dark-tri"><i class="margin-left-x-small margin-right-x-small {{item.icon}}"></i>{{item.title}}</li></a></ul>';
        var directiveDefinitionObject = {
            scope:{
                dropdownList:'=',
                inputElem:'@',
            },
            controller: function($scope) {
                $scope.showDropDown = false;
                $scope.toggleDropDown = function(){
                    $scope.showDropDown = !$scope.showDropDown;
                };
                $scope.loadSelectedDropDown = function(optionSelected){
                    $scope.showDropDown = false;
                    var selectedHtml = '<i class="'+optionSelected.icon+' "></i><i class="icon icon-down-triangle x-small triangle"></i>';
                    $('.selected a').html(selectedHtml);
                    $('.'+$scope.inputElem).attr('placeholder',optionSelected.placeholder);
                };
            },
            template:html
        };
        return directiveDefinitionObject;
}]);